import React, { useState } from 'react';
import useNCZICommandProcess from '../../../Hooks/useNCZICommandProcess';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import { NcziEnum } from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import { VerifyEnumVersion } from '../../../Commands/VerifyEnumVersion';
import moment from 'moment';
import NZCIListItem from '../../Base/NZCIListItem';

//@ts-ignore
import styles from './VerifyVersion.module.scss';
import Loading from '../../../../../Components/Loading';

type VerifyResult = {
  name: string;
  oid: string;
  meddiLast: {
    version: number;
    updatedAt: string;
  };
  ncziLast: {
    version: number;
    updatedAt: string;
  };
}

interface Props {
  item: NcziEnum;
  onClose: () => void;
}

const VerifyVersion: React.FC<Props> = (props) => {
  const {item, onClose} = props;
  const [result, setResult] = useState<VerifyResult|undefined>(undefined);

  const { processingCommandId, processCommand, isProcessing } =
    useNCZICommandProcess({
      onFinish: (id, result) => {
        setResult(result);
      },
      hideSuccess: true
    });

  useEffectAsync(async () => {
    const verifyCommand = VerifyEnumVersion({
      oid: item.oid,
      date: moment().format()
    });

    await processCommand(verifyCommand);
  }, []);

  if (isProcessing && processingCommandId) {
    return <NCZICommandResult commandId={processingCommandId} />;
  }

  if(typeof result === 'undefined') {
    return <Loading />;
  }

  return (
    <div className={styles.wrapper}>
      <NZCIListItem title={'nczi.verifyEnumVersionModal.name'} value={result.name} />
      <NZCIListItem title={'OID'} value={result.oid} />
      <NZCIListItem title={'nczi.verifyEnumVersionModal.meddiLast'} value={result.meddiLast.version} extra={moment(result.meddiLast.updatedAt).format('DD.MM.YYYY')} />
      <NZCIListItem title={'nczi.verifyEnumVersionModal.ncziLast'} value={result.ncziLast.version} extra={moment(result.ncziLast.updatedAt).format('DD.MM.YYYY')} />
    </div>
  );
};

export default VerifyVersion;
